module.exports = __webpack_public_path__ + "static/media/Patterson20241221EventSantaPic.48f50e6c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/Patterson20241221EventSantaPic.jpg
// module id = 290
// module chunks = 0